import { AdminClassroomLayout } from "@/pages/admin/AdminClassroomLayout";
import { AdminClassroomsPage } from "@/pages/admin/AdminClassroomsPage";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/admin/schools/$schoolId/")({
  component: RouteComponent,
});

function RouteComponent() {
  const { schoolId } = Route.useParams();
  return (
    <AdminClassroomLayout>
      <AdminClassroomsPage schoolId={schoolId} />
    </AdminClassroomLayout>
  );
}
